import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { LOGOUT } from '../../../actions'

export class SignOutPage extends Component {
  constructor(props) {
    super()
  }

  componentWillMount() {
    this.props.handleAction(LOGOUT, {})
  }

  render() {
    return null
  }
}

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(null, mapDispatchToProps)(SignOutPage)

SignOutPage.propTypes = {
  handleAction: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/containers/pages/sign-out-page/sign-out-page.js